import { FC, useEffect, useState } from 'react';
import useResponsive from 'src/hooks/contexts/useResponsive';
import { StyledSubpageContainer } from './SubpageContainer.styles';
import { ISubpageContainer } from './SubpageContainer.type';

const SubpageContainer: FC<ISubpageContainer> = ({ type, onReset, onClickOutside, overflow, mdOverflow, children }) => {
	const { isSmallerThanMd } = useResponsive();

	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (!isMounted) {
				return;
			}

			// prevent click outside on arrow button
			const isTargetButtonTag = (event.target as HTMLElement).tagName === 'BUTTON';

			const target = event.target as HTMLElement;
			const container = document.querySelector(`.subpage-container-${type}`);
			const body = document.querySelector('body');
			// check if click is outside of container and body classes does not contain 'modal-open'
			if (
				container &&
				!container.contains(target) &&
				body &&
				!body.classList.contains('modal-open') &&
				!isTargetButtonTag
			) {
				onClickOutside?.();
			}
		};

		if (!isSmallerThanMd) {
			document.addEventListener('click', handleClickOutside);
		}
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [onClickOutside, isSmallerThanMd, type, isMounted]);

	useEffect(() => {
		setIsMounted(true);

		return () => {
			onReset && onReset();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<StyledSubpageContainer
			className={'mobile-full-height subpage-container-' + type}
			overflow={overflow}
			mdOverflow={mdOverflow}
		>
			{children}
		</StyledSubpageContainer>
	);
};

export { SubpageContainer };
